import api from '../../plugins/api';

const editEquipments = ({ id, title, price, count, typeId }) => {
  return api.post('api/crm/equipments/editEquipment', { id, title, price, count, typeId });
};

export default editEquipments;
